import { publicCreateContactMessage } from "../api/services/contactMessagesApi";
import { getErrorMessage } from "../api/errorMessage";

/**
 * POST /v1/public/contact-messages (no auth).
 * @param {Record<string, unknown>} apiBody
 * @returns {Promise<{ ok: true, data: unknown } | { ok: false, errorMessage: string }>}
 */
export async function submitContactMessagePublic(apiBody) {
  try {
    const { data } = await publicCreateContactMessage(apiBody);
    return { ok: true, data: data ?? {} };
  } catch (e) {
    return { ok: false, errorMessage: getErrorMessage(e) };
  }
}
